import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { Subscription, empty } from 'rxjs';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';

@Component({
  selector: 'app-turns-form-schedules-card',
  templateUrl: './turns-form-schedules-card.component.html',
  styleUrls: ['./turns-form-schedules-card.component.scss']
})
export class TurnsFormSchedulesCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;
  @Input() existingSchedules: Schedule[];
  schedules;
  existingSchedule = new FormControl(null);
  updateDaysForm = new FormGroup({
    daysToShowPrivate: new FormControl(null, Validators.required),
    daysToShowPublic: new FormControl(null, Validators.required)
  });
  updateSchedulesSubscription: Subscription;
  updatePrivateFormDaysToShowSubscription: Subscription;
  updatePublicFormDaysToShowSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
    private userStorageService: UserStorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  public addSchedule() {
    if (this.existingSchedule.value === null) {
      this.router.navigate(['schedule'], { relativeTo: this.activatedRoute });
    } else {
      this.formsTurnsService.linkExistingFormSchedule(this.existingSchedule.value.InternalId, this.form.InternalId).pipe(
        tap(o => this.formsTurnsService.refreshForm()),
        tap(o => this.existingSchedule.patchValue(null))
      ).subscribe();
    }
  }

  public editSchedule(schedule) {
    this.router.navigate(['schedule', schedule.InternalId], { relativeTo: this.activatedRoute });
  }

  public privateInputChange() {
    if (this.updateDaysForm.get('daysToShowPrivate').dirty && this.updateDaysForm.get('daysToShowPrivate').valid) {
        this.updatePrivateFormDaysToShow(this.updateDaysForm.get('daysToShowPrivate').value);
    } else {
      this.resetForm();
    }
  }

  public publicInputChange() {
    if (this.updateDaysForm.get('daysToShowPublic').dirty && this.updateDaysForm.get('daysToShowPublic').valid) {
        this.updatePublicFormDaysToShow(this.updateDaysForm.get('daysToShowPublic').value);
    } else {
      this.resetForm();
    }
  }

  public deleteSchedule(schedule) {
    this.updateSchedulesSubscription = this.formsTurnsService.deleteFormSchedule(schedule.InternalId, this.form.InternalId).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public updateSchedules(schedules) {
    this.updateSchedulesSubscription = this.formsTurnsService.updateFormSchedules(this.form.InternalId, this.form.Active, schedules).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.deleteAllRememberedSchedule();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public updatePrivateFormDaysToShow(daysToShow) {
    this.updatePrivateFormDaysToShowSubscription = this.formsTurnsService.updatePrivateFormDaysToShow(this.form.InternalId, daysToShow).pipe(
      tap(res => this.snackbarService.open('turns-page.snackbar messages.update form success', 'success')),
      tap(res => this.formsTurnsService.refreshForm()),
      catchError(error => { console.dir(error); this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  public updatePublicFormDaysToShow(daysToShow) {
    this.updatePublicFormDaysToShowSubscription = this.formsTurnsService.updatePublicFormDaysToShow(this.form.InternalId, daysToShow).pipe(
      tap(res => this.snackbarService.open('turns-page.snackbar messages.update form success', 'success')),
      tap(res => this.formsTurnsService.refreshForm()),
      catchError(error => { console.dir(error); this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private resetForm() {
    this.updateDaysForm.patchValue({
      daysToShowPublic: this.form.DaysToShow,
      daysToShowPrivate: this.form.DaysToShowPrivate
    });
  }

  ngOnDestroy() {
    if (this.updateSchedulesSubscription) { this.updateSchedulesSubscription.unsubscribe(); }
    if (this.updatePrivateFormDaysToShowSubscription) { this.updatePrivateFormDaysToShowSubscription.unsubscribe(); }
    if (this.updatePublicFormDaysToShowSubscription) { this.updatePublicFormDaysToShowSubscription.unsubscribe(); }
  }
}
